import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import OfflineBlockerDialog from '@shared/components/connection/OfflineBlockerDialog';
import ModalProvider from '@shared/components/providers/ModalProvider';
import SessionExpirationWatcher from '@shared/components/session/SessionExpirationWatcher';
import { LoadingFallback } from '@shared/components/ui/LoadingFallback';
import { useSessionManager } from '@shared/hooks';
import Routing from '@routes/Routing';
import store, { persistor } from '@store/store';

import './styles/App.scss';

const SessionManager = () => {
  useSessionManager();
  return null;
};

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<LoadingFallback />} persistor={persistor}>
      <BrowserRouter>
        <SessionManager />
        <Routing />
        <ModalProvider />
        <SessionExpirationWatcher />
        <OfflineBlockerDialog />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

export default App;
